import z from 'zod';
import { Region } from '../../referential/Region';
import { SSD2Id } from '../../referential/Residue/SSD2Id';
import { Matrix } from '../Matrix/MatrixReferential';

export const ResidueDetectionStat = z.object({
  residueReference: SSD2Id,
  matrix: Matrix,
  region: Region,
  sampleCount: z.coerce.number(),
  higherThanArfdCount: z.coerce.number().default(0)
});

export const FindResidueStatsOptions = z.object({
  programmingPlanId: z.guid().nullish()
});

export type ResidueDetectionStat = z.infer<typeof ResidueDetectionStat>;
export type FindResidueStatsOptions = z.infer<typeof FindResidueStatsOptions>;
